import { createContext } from 'react';

export const MonthContext = createContext({ visible: true });
